jQuery(document).ready(function ($) {
    function getRecaptchaToken(siteKey) {
        return new Promise((resolve) => {
            grecaptcha.enterprise.ready(async () => {
                resolve(await grecaptcha.enterprise.execute(siteKey, {action: 'LOGIN'}));
            });
        });
    }

    $.fn.submitForm = async function () {
        const section = this.closest('.pricing-calculator__presubmission');
        const container = section.parent();
        const fields = section.find('.pricing-calculator__form input');

        const service_names = (window.arise_pc_state.all_services || [])
            .map(window.arise_pc_get_service_name)
            .join(', ');

        dataLayer.push({
            event: 'submitting_calculator_form',
            service_names: service_names
        });

        const data = [];

        fields.each(function () {
            const $field = $(this);
            const value = $field.is(':checkbox') ? ($field.is(':checked') ? $field.val() : '') : $field.val();

            data.push(JSON.stringify([$field.attr('name'), value]));
        });

        const captcha = arise_pc.captcha;
        const google_site_key = captcha.google_site_key;
        const recaptcha_enabled = captcha.google_enabled;

        let token = false;

        if (recaptcha_enabled) {
            token = await getRecaptchaToken(google_site_key);
        }

        $.ajax({
            url: arise_pc.ajax_url,
            type: 'POST',
            data: {
                form: JSON.stringify(data),
                grecaptcha: token,

                action: 'arise_pc_submit_results_form',
                nonce: arise_pc.nonce
            },

            beforeSend: function () {
                section.addClass('loading');
            },

            success: function (response) {
                section.removeClass('loading');

                dataLayer.push({
                    event: 'calculator_form_submitted',
                    service_names: service_names
                });

                section.fadeOut(250);

                setTimeout(function () {
                    container.append(response.data.results);

                    const results = container.children().last();

                    results.fadeIn(250);
                    window.arise_pc_set_step(4, results);
                }, 250);

                $('html, body').animate({ scrollTop: container.closest('.pricing-calculator').offset().top - ($('.heading-links').outerHeight() || 0) }, 250);
            },

            error: function (response) {
                const message = section.find('.pricing-calculator__message');
                message.text('');

                try {
                    const data = JSON.parse(response.responseText).data;
                    Object.values(data).forEach(function (value) {
                        const span = $('<span></span>').append(document.createTextNode(value))
                        message.append(span);
                    });
                } catch (e) {
                    message.append(document.createTextNode(response.responseText));
                }

                message.fadeIn(250);

                $('html, body').animate({ scrollTop: container.closest('.pricing-calculator').offset().top - ($('.heading-links').outerHeight() || 0) }, 250);
            },

            complete: function () {
                section.removeClass('loading');
            }
        });
    }

    $(document).on('click', '.pricing-calculator__submit', function (event) {
        event.preventDefault();

        $(this).submitForm();
    });
});